var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("图标选择器")]),
      _c("div", { staticClass: "title-group" }, [
        _c("p", { staticClass: "title" }, [_vm._v("一般用法")]),
        _c(
          "p",
          { staticClass: "sub-title" },
          [
            _vm.icon
              ? [
                  _vm._v(" 选择的图标 " + _vm._s(_vm.icon) + " "),
                  _c("i", { class: "fa fa-" + _vm.icon })
                ]
              : [_vm._v("未选择")]
          ],
          2
        )
      ]),
      _c("d2-icon-select", {
        model: {
          value: _vm.icon,
          callback: function($$v) {
            _vm.icon = $$v
          },
          expression: "icon"
        }
      }),
      _c("div", { staticClass: "title-group" }, [
        _c("p", { staticClass: "title" }, [_vm._v("用户可以输入")]),
        _c(
          "p",
          { staticClass: "sub-title" },
          [
            _vm.icon2
              ? [
                  _vm._v(" 选择的图标 " + _vm._s(_vm.icon2) + " "),
                  _c("i", { class: "fa fa-" + _vm.icon2 })
                ]
              : [_vm._v("未选择")]
          ],
          2
        )
      ]),
      _c("d2-icon-select", {
        attrs: { "user-input": true },
        model: {
          value: _vm.icon2,
          callback: function($$v) {
            _vm.icon2 = $$v
          },
          expression: "icon2"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }